export default "__VITE_ASSET__C35HzFy8__";